import { z } from "zod"

// `?projectId=`, `?iteration=` and `?responseId=` on the survey complete page. Links build them
// from numbers, but My Stuff used to write `projectId=null` and a hand-edited
// URL can carry anything. Anything that is not a positive integer becomes
// undefined, so the page sees either a real id or none (BAB-1011).
const positiveInt = z.preprocess((value) => {
  if (value === undefined || value === null || value === "") return undefined
  const n = typeof value === "number" ? value : Number(value)
  return Number.isInteger(n) && n > 0 ? n : undefined
}, z.number().int().positive().optional())

export const surveyCompleteSearchSchema = z.object({
  projectId: positiveInt,
  iteration: positiveInt,
  responseId: positiveInt,
})

export type SurveyCompleteSearch = z.infer<typeof surveyCompleteSearchSchema>
